import { show, hide } from '../util/show'
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock/lib/bodyScrollLock.min.js'
import getFocusTrapEventHandler from './focus_trap'

const modalSelector = '.js-modal_redesign'
const openModalButtonSelector = '.js-open_modal_redesign'
const closeModalButtonSelector = '.js-close_modal_redesign'
const modalContentSelector = '.js-modal_redesign_content'

// An example of an accessible modal that was used as inspiration:
// http://ncamftp.wgbh.org/sp/tests/dialog/modalDialog.html

export function open(modal) {
  const modalContent = modal.querySelector(modalContentSelector)
  show(modal)
  // the effects of this function call are only observable on iOS
  disableBodyScroll(modal.querySelector('.modal__inner'))
  modalContent.focus()
}

function close(modal) {
  clearAllBodyScrollLocks()
  hide(modal)

  function restoreFocus() {
    // when I close the modal, I want to be brought back to the button that opened it,
    // and if it doesn't exist, then... do nothing - there are no good choices :( modals that open themselves are terrible accessibility-wise
    const openModalButtons = Array.from(document.querySelectorAll(openModalButtonSelector))
    const button = openModalButtons.find(function (button) {
      const overlaySelector = button.dataset.openModal

      return document.querySelector(overlaySelector) === modal
    })

    if (button) {
      button.focus()
    }
  }

  restoreFocus()
}

// if you edit the modal's behavior here, you might need to edit assets/js/components/rich_text_editor/new_embed_modal.jsx too
up.compiler(modalSelector, function (element) {
  if (element.dataset.autoOpen) {
    open(element)
  }

  const { onFocus } = getFocusTrapEventHandler(element)

  element.addEventListener('keydown', function (e) {
    if (e.code === 'Escape') {
      close(element)
      return false
    }

    onFocus(e)
  })
})

up.on('click', openModalButtonSelector, function (event, element) {
  const overlaySelector = element.dataset.openModal
  open(document.querySelector(overlaySelector))
  event.preventDefault()
  return false
})

up.on('click', closeModalButtonSelector, function (event, element) {
  close(element.closest(modalSelector))
  event.preventDefault()
  return false
})

up.on('click', modalSelector, function (event, element) {
  if (event.target === this) {
    close(element)
  }
})

up.on('up:fragment:destroyed', function (event) {
  const { fragment } = event
  if (fragment.querySelector(modalSelector)) {
    clearAllBodyScrollLocks()
  }
})
